import api, { rawClient } from './api';
import {
    GuaranteePolicyEndorsementSnapshot,
    GuaranteePolicyTenantSnapshot,
    GuaranteeInstallmentSnapshot,
    NoIdGuaranteePolicyResponse,
} from '../models';
import { keyBy } from '../lib';
import { ZipcodeSnapshot } from '../models/AutoFill/Zipcode';
import { getBackVersion } from '../config';

export type RawGuaranteePolicyResponse = Omit<
    NoIdGuaranteePolicyResponse,
    'tenants' | 'endorsements'
> & {
    tenants: GuaranteePolicyTenantSnapshot[];
    endorsements: GuaranteePolicyEndorsementSnapshot[];
};

export const policyToSnapshot = ({
    tenants,
    endorsements,
    ...response
}: RawGuaranteePolicyResponse): NoIdGuaranteePolicyResponse => {
    return {
        ...response,
        tenants: keyBy(tenants, x => x.cpf),
        endorsements: keyBy(endorsements, x => x.endorsementNumber),
    };
};

const getPolicy = (
    insuranceId: string,
    endorsementNumber?: number
): Promise<NoIdGuaranteePolicyResponse> => {
    return api
        .request<RawGuaranteePolicyResponse>({
            method: 'GET',
            url: `${getBackVersion()}/agent/insurances/guarantee/${insuranceId}/policy`,
            params: endorsementNumber && {
                /* eslint camelcase: 0 */
                endorsement_number: endorsementNumber,
            },
        })
        .then(policyToSnapshot);
};

const getInstallments = (
    insuranceId: string
): Promise<GuaranteeInstallmentSnapshot[]> => {
    return api.request<GuaranteeInstallmentSnapshot[]>({
        method: 'GET',
        url: `${getBackVersion()}/agent/insurances/guarantee/${insuranceId}/installments`,
    });
};

const getAddressByZipcode = (
    insuranceId: string,
    zipcode: string
): Promise<ZipcodeSnapshot> =>
    api.request<ZipcodeSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/agent/insurances/guarantee/${insuranceId}/zipcode/${zipcode}`,
    });

const policyDownload = (psInsuranceId: string): Promise<void> => {
    return rawClient.download({
        method: 'GET',
        url: `${getBackVersion()}/agent/insurances/guarantee/${psInsuranceId}/policy/download`,
    });
};

export default {
    getAddressByZipcode,
    getInstallments,
    getPolicy,
    policyDownload,
};
